import { Component, EventEmitter, HostListener, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'clearcals-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WidgetComponent {

  @Input() id: string;
  @Output() setActiveItem: EventEmitter<string>;

  constructor() {
    this.setActiveItem = new EventEmitter();
   }


  @HostListener('click', ['$event.target']) onClick(): void {
    this.setActiveItem.next(this.id);
  }

}

export default WidgetComponent;
